import r from "./SharedContentErrorNode-Yt5TcaXb.js";
import { resolveComponent as e, openBlock as n, createBlock as t } from "vue";
import { _ as a } from "./main-Df9wF57H.js";
const d = {
  name: "EditableSharedContentErrorNode",
  components: {
    SharedComponentErrorNode: r
  }
};
function p(c, m, s, _, f, i) {
  const o = e("SharedComponentErrorNode");
  return n(), t(o);
}
const C = /* @__PURE__ */ a(d, [["render", p]]);
export {
  C as default
};
